import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ClientLogos from './components/ClientLogos';
import Stats from './components/Stats';
import VSL from './components/VSL';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import EmailPortfolio from './components/EmailPortfolio';
import Methodology from './components/Methodology';
import Comparison from './components/Comparison';
import About from './components/About';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ThankYouPage from './components/ThankYouPage';

function Home() {
  return (
    <div className="App bg-[var(--ob-bg)]">
      <Navbar />
      <main>
        <Hero />
        <ClientLogos />
        <Stats />
        <VSL />
        <Services />
        <CaseStudies />
        <Testimonials />
        <EmailPortfolio />
        <Methodology />
        <Comparison />
        <About />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/strategy-call-booked" element={<ThankYouPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
